import React from "react";
import { useSelector } from "react-redux";

const ProjeKart = ({ project, selectedProject, onSelect, isHighlighted }) => {
  const image = useSelector((state) => state.projects.imageMap?.[project.id]);
  const loading = useSelector((state) => state.projects.loading);

  const getStatusColor = (status) => {
    switch (status) {
      case "Devam Ediyor":
        return "text-success";
      case "Henüz Başlamadı":
        return "text-customBlue";
      case "Tamamlandı":
        return "text-orange";
      default:
        return "text-grayy"; // Varsayılan renk
    }
  };

  // Yeni proje kontrolü - startedAt'den itibaren 7 gün içinde mi?
  const isNewProject = () => {
    if (project.startedAt == null) return true;
    const startDate = new Date(project.startedAt);
    const now = new Date();
    const diffTime = now - startDate;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);
    return diffDays <= 7;
  };

  // Maksimum üye sayısını statik olarak belirtiyoruz (geçici çözüm)
  const maxMembers = 5;
  if (!project) {
    //console.warn("project prop'u yok veya undefined!");
    return null;
  }

  // console.log("Project ID:", project.id, "Loaded Image:", image);
  return (
    <div
      className={`container mx-auto shadow-cardShadow rounded-2xl h-auto w-full p-4 cursor-pointer transition ${
        selectedProject?.id === project.id
          ? "border-2 border-kartGreen"
          : isHighlighted
          ? "border-2 border-darkerGreen"
          : "border-transparent"
      }`}
      onClick={() => onSelect(project)}
    >
      {/* Üst Kısım - Proje Bilgileri */}
      <div className="flex flex-row gap-4 w-full">
        {/* Proje Görseli */}
        <div className="flex-shrink-0">
          <img
            src={
              loading || !image
                ? "/projeimg-green.svg"
                : `data:image/jpeg;base64,${image}`
            }
            alt="Proje Image"
            className="w-[85px] h-[85px] rounded-lg border border-[#CBD4E1] object-cover"
            onError={() => console.log("Image failed to load for", project.id)}
          />
        </div>
        {/* Başlık ve Açıklama */}
        <div className="flex-1 min-w-0">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 mb-2">
            <h3 className="text-lg font-semibold text-dark truncate">
              {project.title}
            </h3>
            <div className="flex gap-2">
              {isNewProject() && (
                <span className="text-xs bg-greenn text-dark px-2 py-1 rounded-md inline-block w-fit">
                  Yeni Proje
                </span>
              )}
              <span className="text-xs bg-lighterGreen text-dark px-2 py-1 rounded-md inline-block w-fit">
                {project.type.charAt(0).toUpperCase() +
                  project.type.slice(1).toLowerCase()}
              </span>
            </div>
          </div>
          <p className="text-sm text-gray-500 line-clamp-2">
            {project.description ||
              project.definition ||
              "Açıklama belirtilmemiş"}
          </p>
        </div>
      </div>

      {/* Alt Kısım - Proje Durumu */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center text-sm text-gray-600 border-t pt-3 mt-3 gap-2">
        <span className="flex items-center gap-1 font-medium">
          <span
            className={`text-base leading-none ${getStatusColor(
              project.status
            )}`}
          >
            ●
          </span>
          <span className="text-dark text-xs">{project.status}</span>
        </span>
        <div className="flex flex-row justify-between items-center gap-2 w-full sm:w-auto">
          {/*Üye Sayısı*/}
          <span className="flex items-center gap-1.5 text-xs text-dark w-[100px] min-w-[100px] whitespace-nowrap overflow-hidden">
            <img
              src="/person.svg"
              alt="Üyeler"
              className="w-4 h-4 flex-shrink-0"
            />
            {project.memberCount || 0}/{project.allPositionCount || 0} Üye
          </span>
          {/*<span className="border-l border-gray border-2 h-5"></span>*/}
         {/* <span className="flex items-center gap-1.5 text-xs text-dark w-[100px] min-w-[100px] whitespace-nowrap overflow-hidden">
            <img
              src="/time.svg"
              alt="Kalan Süre"
              className="w-5 h-5 flex-shrink-0"
            />
            {project.timeDisplay}
          </span>*/ }
        </div>
      </div>
    </div>
  );
};

export default ProjeKart;
